import {GameDetail} from '../../types/game'
import Slider from '@app/components/sliders/slider/slider-client'
import s from '../mobile/style.module.css'
import SimilarGameMobile from '../similar-games/non-desktop'
import {LanguageCodes} from '@app/i18n/settings'

type Props = {
  similarGames: GameDetail[]
  theme: string
  isIOS: boolean
  lang: LanguageCodes
  propertyCode: string
  subId: string
}

const SimilarGamesSlider = ({similarGames, theme, isIOS, lang, propertyCode, subId}: Props) => {
  return (
    <Slider arrowsVisible={false}>
      <div className={s.similar_games_wrapper}>
        {similarGames.map((game, index) => {
          return (
            <SimilarGameMobile
              key={game.code}
              index={index}
              game={game}
              cardCss={s.card}
              lang={lang}
              propertyCode={propertyCode}
              subId={subId}
            />
          )
        })}
      </div>
    </Slider>
  )
}

export default SimilarGamesSlider
